import {
  FinancialApplicationFormSectionContextType,
  FinancialApplicationFormValidationDisplayBehavior,
} from "@/hooks/useFinancialApplicationFormSectionValidation";
import { BasicInformationForm } from "../BasicInformation/BasicInformationForm";
import { TaskExecutionModuleFormProps } from "@bolt/task";
import { FinancialApplicationDocumentsForm } from "../FinancialApplicationDocuments/FinancialApplicationDocumentsForm";

export interface FinancialApplicationExpressionSchemaTaskExecutionTypeFormProps
  extends TaskExecutionModuleFormProps {}

export const FinancialApplicationExpressionSchemaTaskExecutionTypeForm: React.FC<
  FinancialApplicationExpressionSchemaTaskExecutionTypeFormProps
> = (props) => {
  return (
    <>
      <BasicInformationForm
        financialApplicationId={props.entityId || ""}
        availableFields={props.availableFields}
        autoValidationBehavior={
          FinancialApplicationFormValidationDisplayBehavior.AlwaysDisplayValidationErrors
        }
        showHeader={true}
        validationContextType={FinancialApplicationFormSectionContextType.Task}
        shouldShowDigitalBankingFields={true}
        shouldShowDebitCardFields={true}
      />
      <FinancialApplicationDocumentsForm
        financialApplicationId={props.entityId || ""}
        availableFields={props.availableFields}
        autoValidationBehavior={
          FinancialApplicationFormValidationDisplayBehavior.AlwaysDisplayValidationErrors
        }
        showHeader={true}
      />
    </>
  );
};
